import React, { PureComponent } from 'react';
import moment from 'moment';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router-dom';
import { Col, Row } from 'elements';

import * as ROUTES from 'config/routes';
import GridCards from './components/grid-cards';
import ZoneFilter from './components/zone-filter';
import FilterBar from './components/filter-bar'
import { holdersSelector, userSelector, operatorSiteDetailsSelector, operatorSiteDetailsStatusSelector, zonesCheckinCheckoutInfoSelector } from 'redux/selectors'
import SecurityMessaging from './components/security-messaging';
import {
	listSites,
	listZones,
	listenToSubscriptions,
	listenToThermalSubscriptions,
	listenToFaceSubscriptions,
	listenToWifiSubscriptions,
	listenToSecuritySubscriptions,
	listCheckinCheckoutZones
} from 'redux/modules/model/site';
import { logUserTab } from 'redux/modules/user/index'
import { getOperatorSite } from 'redux/modules/model/operator'
import { liveViewEnabledRedir } from 'hocs/auth';
import { PageContainer } from 'smart-components';
import { PageContent } from 'components';
import { parseQueryString, jsonToQueryString } from 'utils/helpers';
import {
	liveDiscoverySelector,
	liveThermalDiscoverySelector,
	liveFaceDiscoverySelector,
	liveWifiDiscoverySelector,
	liveSecurityMessagingSelector,
} from 'redux/selectors';
import { listHolders } from 'redux/modules/model/holder'
import { userIsAuthenticatedRedir } from 'hocs/auth';
import { withClientId } from 'hocs';
import { ZONE_ENTITIES_VALIDATE_INTERVAL } from 'config/constants';
import * as actions from '@/redux/new_store_structure/actions';
import { wsClient } from '@/index';

const thermalSelector = [
	{ name: 'All Persons', value: 'null' },
	{ name: 'Fever Detected', value: 'fever' },
	{ name: 'Without Fever', value: 'none' },
];

class LiveView extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			queryParams: {
				view: 'large',
				...parseQueryString(this.props.location.search),
			},
			siteId: null,
			zoneId: null,
			allSitesList: [],
			wifiList: [],
			showZoneItems: false,
		};
	}

	componentDidMount() {
		console.log("🚀 ~ LiveView ~ componentDidMount ~ componentDidMount:")
		const { getSitesList, clientId, listHolders, logUserTab, user, getOperatorSite, listCheckinCheckoutZones } = this.props;
		console.log("🚀 ~ LiveView ~ componentDidMount ~ this.props:", this.props)
		const operator = user && user.currentUser && user.currentUser.operator
		getSitesList({ clientId });
		listCheckinCheckoutZones({ clientId })
		getOperatorSite({ clientId, username: operator.username });
		const activeFilter = { active: true }
		listHolders({ clientId, filter: activeFilter, with: 'metadata' })
		this.timerId = window.setInterval(
			this.props.clearInactiveEntities,
			ZONE_ENTITIES_VALIDATE_INTERVAL,
		);
		const tab = "Live View"
		logUserTab({ clientId, tab })
	}
	componentDidUpdate(prevProps, prevState) {
		const { siteId, zoneId } = this.state;
		const { sitesList, clientId, getZonesList, zonesList, discoveredList, user, wifiAlertsList } = this.props;
		const operator = user && user.currentUser && user.currentUser.operator
		let defaultSite = operator.default_site
		this.setState({ allSitesList: discoveredList })
		this.setState({ wifiList: wifiAlertsList })
		if (siteId === "null" || clientId === 'unifiid-demo' || clientId === 'tsb' || clientId === 'test-club') {
			prevProps.discoveredList.forEach(record => {
				discoveredList.forEach((newRecord, i) => {
					if (record.clientReference === newRecord.clientReference) {
						if (record.detectionTime > newRecord.detectionTime) {
							var item = {
								detectionTime: record.detectionTime,
								clientReference: record.clientReference,
								siteId: record.siteId,
								zoneId: record.zoneId
							}
							discoveredList[i] = item
							this.setState({ allSitesList: discoveredList })
						}
					}
				})
			})
			this.state.allSitesList.forEach(record => {
				discoveredList.forEach((newRecord, i) => {
					if (record.clientReference === newRecord.clientReference) {
						if (record.detectionTime > newRecord.detectionTime) {
							var item = {
								detectionTime: record.detectionTime,
								clientReference: record.clientReference,
								siteId: record.siteId,
								zoneId: record.zoneId
							}
							discoveredList[i] = item
							this.setState({ allSitesList: discoveredList })
						}
					}
				})
			})
		}

		if (siteId === "tramp") {
			console.log("🚀 ~ LiveView ~ componentDidUpdate ~ prevProps.wifiAlertsList:", prevProps.wifiAlertsList)
			console.log("🚀 ~ LiveView ~ componentDidUpdate ~ wifiAlertsList:", wifiAlertsList)
			if (wifiAlertsList && wifiAlertsList.length > 0 && prevProps.wifiAlertsList && prevProps.wifiAlertsList.length > 0) {
				prevProps.wifiAlertsList.forEach(record => {
					wifiAlertsList.forEach((newRecord, i) => {
						if (record.clientReference === newRecord.clientReference) {
							console.log("🚀 ~ LiveView ~ wifiAlertsList.forEach ~ Math.abs(record.detectionTime - newRecord.detectionTime):", Math.abs(new Date(record.detectionTime).getTime() - new Date(newRecord.detectionTime).getTime()))
							console.log("🚀 ~ LiveView ~ wifiAlertsList.forEach ~ newRecord.detectionTime.getTime():", new Date(record.detectionTime).getTime())
							console.log("🚀 ~ LiveView ~ wifiAlertsList.forEach ~ record.detectionTime.getTime():", new Date(newRecord.detectionTime).getTime())
							if (Math.abs(new Date(record.detectionTime).getTime() - new Date(newRecord.detectionTime).getTime()) < 5 * 60 * 1000) {
								console.log("inside if")
								var item = {
									detectionTime: record.detectionTime,
									clientReference: record.clientReference,
									siteId: record.siteId,
									zoneId: record.zoneId
								}
								console.log("🚀 ~ LiveView ~ wifiAlertsList.forEach ~ item:", item)
								wifiAlertsList[i] = item
								this.setState({ wifiList: wifiAlertsList })
							}
						}
					})
				})
			}
		}
		console.log("🚀 ~ LiveView ~ wifiAlertsList.forEach ~ wifiAlertsList:", wifiAlertsList)
		console.log("🚀 ~ LiveView ~ componentDidUpdate ~ siteId:", siteId)
		console.log("🚀 ~ LiveView ~ componentDidUpdate ~ prevState.siteId:", prevState.siteId)
		if (siteId && prevState.siteId !== siteId) {
			getZonesList({ clientId, siteId });
			this.subscribe();
			this.setShowZoneItems();
		}
		if (sitesList && sitesList.length > 0 && !siteId) {
			if (defaultSite) {
				this.handleSiteChange(defaultSite);
			} else {
				this.handleSiteChange(sitesList[0].siteId);
			}
		}
		if (zonesList && zonesList.length > 0 && !zoneId && siteId) {
			const newZone =
				zonesList && zonesList.length === 1
					? zonesList[0].zoneId
					: 'null';
			this.handleZoneChange(newZone);
		}
	}

	componentWillUnmount() {
		this.timerId && window.clearInterval(this.timerId);
		this.unsubscribe();
	}

	setShowZoneItems = () => this.setState({ showZoneItems: true });

	setURLHref(params) {
		const { history } = this.props;
		history.push({
			location: ROUTES.LIVE_VIEW_DIRECTORY,
			search: jsonToQueryString(params),
		});
	}

	handleFilterChange = value => {
		const { filters, grouping, view, search } = this.state.queryParams;
		let newFilters = filters;

		const key = Object.keys(value)[0];
		const position = filters.indexOf(key);
		if (value[key] && position === -1) {
			newFilters.push(key);
		}

		if (!value[key] && position !== -1) {
			newFilters = [
				...filters.slice(0, position),
				...filters.slice(position + 1),
			];
		}

		this.setURLHref({
			filters: newFilters,
			grouping,
			view,
			search,
		});
	};

	handleViewModeChange = view => {
		this.setURLHref({
			...this.state.queryParams,
			view,
		});
	};

	handleSearch = search => {
		this.setURLHref({
			...this.state.queryParams,
			search: encodeURIComponent(search),
		});
	};

	handleSearchChange = e => {
		this.setState({
			search: e.target.value,
		});
		const params = {
			...parseQueryString(location.search),
			search: e.target.value,
		};
		this.setURLHref(params);
	};

	handleSiteChange = siteId => {
		const newQueryStr = {
			...this.state.queryParams,
			site: encodeURIComponent(siteId),
			zone: 'null',
			search: this.state.search
		};
		this.setURLHref(newQueryStr);
		this.setState({ queryParams: newQueryStr, siteId });
	};

	handleZoneChange = zoneId => {
		const newQueryStr = {
			...this.state.queryParams,
			zone: encodeURIComponent(zoneId),
			search: this.state.search
		};
		this.setURLHref(newQueryStr);
		this.setState({ queryParams: newQueryStr, zoneId });
	};

	handleThermalChange = val => {
		const newQueryStr = {
			...this.state.queryParams,
			thermal: encodeURIComponent(val),
		};
		this.setURLHref(newQueryStr);
		this.setState({ queryParams: newQueryStr, thermal: val });
	};

	subscribe = () => {
		const { siteId } = this.state;
		const {
			listenToSubscriptions,
			listenToThermalSubscriptions,
			listenToFaceSubscriptions,
			listenToWifiSubscriptions,
			listenToSecuritySubscriptions,
			clientId,
			verticalConfig,
			sitesList
		} = this.props;
			console.log("🚀 ~ LiveView ~ clientId:", clientId)
		const enabledVerticals = Object.keys(verticalConfig);
		if (clientId === 'unifiid-demo' || clientId === 'tsb' || clientId === 'test-club') {
			sitesList.forEach(site => {
				const currentSite = site.siteId
				listenToSubscriptions({
					clientId,
					siteId: currentSite,
					includeLastKnown: true, // cutoff = Instant.now().minus(LAST_KNOWN_DETECTIONS_CUTOFF); LAST_KNOWN_DETECTIONS_CUTOFF = Duration.ofDays(1);
				});
				listenToWifiSubscriptions({
					clientId,
					siteId,
					includeLastKnown: true,
				});
				console.log("after listenToWifiSubscriptions")
			})
		} else {
			if (siteId === 'null') {
				sitesList.forEach(site => {
					const currentSite = site.siteId
					listenToSubscriptions({
						clientId,
						siteId: currentSite,
						includeLastKnown: true, // cutoff = Instant.now().minus(LAST_KNOWN_DETECTIONS_CUTOFF); LAST_KNOWN_DETECTIONS_CUTOFF = Duration.ofDays(1);
					});
					listenToWifiSubscriptions({
						clientId,
						siteId,
						includeLastKnown: true,
					});
					console.log("after listenToWifiSubscriptions")
				})
			} else {
				listenToSubscriptions({
					clientId,
					siteId,
					includeLastKnown: true, // cutoff = Instant.now().minus(LAST_KNOWN_DETECTIONS_CUTOFF); LAST_KNOWN_DETECTIONS_CUTOFF = Duration.ofDays(1);
				});
				listenToWifiSubscriptions({
					clientId,
					siteId,
					includeLastKnown: true,
				});
				console.log("after listenToWifiSubscriptions")
			}
		}
		if (enabledVerticals.includes('thermal')) {
			listenToThermalSubscriptions({
				clientId,
				siteId,
				includeLastKnown: true,
			});
			listenToSecuritySubscriptions({
				clientId,
				siteId,
				includeLastKnown: true,
			});
		}
		if (enabledVerticals.includes('face')) {
			listenToFaceSubscriptions({
				clientId,
				siteId,
				includeLastKnown: true,
			});
		}
		// if (enabledVerticals.includes('wifi')) {
			// listenToWifiSubscriptions({
			// 	clientId,
			// 	siteId,
			// 	includeLastKnown: true,
			// });
			// console.log("after listenToWifiSubscriptions")
		// }
	};
	unsubscribe = () => {
		wsClient.clearAllCorrelations('core.site.subscribe-detections');
		wsClient.clearAllCorrelations('thermal.site.subscribe-thermal-events');
		wsClient.clearAllCorrelations(
			'thermal.site.subscribe-security-messages',
		);
	};

	render() {
		const {
			queryParams: { zone: zoneId, site: siteId, thermal: thermalId },
		} = this.state;
		const { allSitesList, wifiList } = this.state;
		console.log("🚀 ~ LiveView ~ render ~ wifiList:", wifiList)
		const params = parseQueryString(location.search)
		let search = params.search

		const {
			discoveredList,
			thermalAlertsList,
			faceAlertsList,
			wifiAlertsList,
			securityMessages,
			zonesList: zones,
			sitesList: sites,
			verticalConfig,
			holdersList,
			operatorSite,
			clientId,
			zonesCheckinCheckoutInfo,
			user
		} = this.props;
		console.log("🚀 ~ LiveView ~ render ~ wifiAlertsList:", wifiAlertsList)
		// let filteredSites = []
		if (operatorSite) {
			if (operatorSite.length > 0) {
				const operatorSites = [];
				operatorSite.forEach(operator => {
					operatorSites.push(operator.siteId)
				})
				sites.forEach((site, i) => {
					if (!operatorSites.includes(site.siteId)) {
						sites.splice(i, 1)
					}
				})
				// filteredSites = sites.filter((site) => operatorSites.includes(site.siteId));
			}
		}
		let clientReferencesList = []
		holdersList.forEach((holder, i) => {
			if (holder.name.toUpperCase().includes((search || "").toUpperCase()) || !search) {
				clientReferencesList.push(holder.clientReference)
			}
		})
		let birthdays = []
		let expiredMembers = []
		let newMembers = []
		let topSpenders = []
		const today = new Date()
		holdersList.forEach((holder, i) => {
			if(holder.metadata){
				if (holder.metadata.dob) {
					const day = holder.metadata.dob.substr(0, 2)
					const month = holder.metadata.dob.substr(3, 2)
					if (('0' + today.getDate()).slice(-2) === day && today.getMonth() + 1 == month) {
						birthdays.push(holder.clientReference)
					}
				}
			}
			if (clientId === 'gleneagles' || clientId === 'unifiid-demo') {
				if (holder.since) {
					const day = holder.since.substr(8, 2)
					const month = holder.since.substr(5, 2)
					const year = holder.since.substr(0, 4)
					const creationDate = new Date(year, month - 1, day);
					const timeDifference = today - creationDate;
					const daysDifference = timeDifference / (1000 * 60 * 60 * 24);
					if (daysDifference < 30) {
						newMembers.push(holder.clientReference)
					}
				}
				if(holder.metadata){
					if (holder.metadata.DoB) {
						if (holder.metadata.DoB.includes("/")) {
							const day = holder.metadata.DoB.substr(0, 2)
							const month = holder.metadata.DoB.substr(3, 2)
							if (('0' + today.getDate()).slice(-2) === day && today.getMonth() + 1 == month) {
								birthdays.push(holder.clientReference)
							}
						} else if (holder.metadata.DoB.includes("-")) {
							const month = holder.metadata.DoB.substr(5, 2)
							const day = holder.metadata.DoB.substr(8, 2)
							if (('0' + today.getDate()).slice(-2) === day && today.getMonth() + 1 == month) {
								birthdays.push(holder.clientReference)
							}
						}
					}
					if (holder.metadata['Membership Status']) {
						if(holder.metadata['Membership Status'] !== 'active')
							expiredMembers.push(holder.clientReference)
					}
					if (holder.metadata['Top Spender']) {
						if(holder.metadata['Top Spender'] === true)
							topSpenders.push(holder.clientReference)
					}
				}
			}
		})
		allSitesList.forEach((item, i) => {
			allSitesList[i].source = "UHF Detection"
			if (birthdays.includes(item.clientReference)) {
				allSitesList[i].birthday = true
			}
			if (newMembers.includes(item.clientReference)) {
				allSitesList[i].newMember = true
			}
			if (expiredMembers.includes(item.clientReference)) {
				allSitesList[i].expiredMember = true
			}
			if (topSpenders.includes(item.clientReference)) {
				allSitesList[i].topSpender = true
			}
		})
		let timeFilteredList = allSitesList
		console.log("🚀 ~ LiveView ~ render ~ timeFilteredList:", timeFilteredList)
		
		let zoneFilteredList = timeFilteredList
		var d = new Date();
		d.setHours(0, 0, 0, 0);
		if (clientId === 'tsb' || clientId === 'test-club' || clientId === 'tds'  || clientId === 'arlextest') {
			timeFilteredList = allSitesList.filter(
				detection => new Date(detection.detectionTime) > d
			)
			// let checkinSites = []
			// let checkinZones = []
			// zonesCheckinCheckoutInfo.forEach(zoneCheckinCheckout => {
			// 	if (zoneCheckinCheckout.checkin) {
			// 		checkinSites.push(zoneCheckinCheckout.siteId)
			// 		checkinZones.push(zoneCheckinCheckout.zoneId)
			// 	}
			// })

			// zoneFilteredList = timeFilteredList.filter(
			// 	detection => checkinSites.includes(detection.siteId) && checkinZones.includes(detection.zoneId)
			// );
			const checkinZones = zonesCheckinCheckoutInfo
				.filter(zone => zone.checkin)
				.map(zone => `${zone.siteId}-${zone.zoneId}`);
			
			zoneFilteredList = timeFilteredList.filter(
				detection => checkinZones.includes(`${detection.siteId}-${detection.zoneId}`)
			);
			console.log("🚀 ~ LiveView ~ render ~ zoneFilteredList:", zoneFilteredList)
		}

		// if (clientId === 'fora') {
		// 	zoneFilteredList = allSitesList.filter(
		// 		detection => new Date(detection.detectionTime) > d
		// 	)
		// }
		let newDiscoveredList = zoneFilteredList.filter(
			el => clientReferencesList.indexOf(el.clientReference) !== -1
		);

		const enabledVerticals = Object.keys(verticalConfig);

		const thermalMap = thermalAlertsList.reduce((res, val) => {
			res[val.clientReference] = val;
			return res;
		}, {});
		console.log("🚀 ~ LiveView ~ thermalMap ~ thermalAlertsList:", thermalAlertsList)

		const faceMap = faceAlertsList.reduce((res, val) => {
			res[val.clientReference] = val;
			return res;
		}, {});
		console.log("🚀 ~ LiveView ~ render ~ faceMap:", faceMap)

		const wifiMap = wifiList 
			? wifiList.reduce((res, val) => {
				res[val.clientReference] = val;
				return res;
				}, {})
			: {};

			// if contains presence, ignore

		console.log("🚀 ~ LiveView ~ wifiMap ~ wifiMap:", wifiMap)

		const discoveredMap = new Map(
			newDiscoveredList.map((item) => [item.clientReference, item])
		  );		  

		Object.entries(wifiMap).forEach(([clientReference, wifiData]) => {
			const existingEntry = discoveredMap.get(clientReference);

			if (existingEntry) {
			  const wifiTime = new Date(wifiData.detectionTime);
			  const newTime = new Date(existingEntry.detectionTime);
		  
			  if (wifiTime > newTime) {
				existingEntry.detectionTime = wifiData.detectionTime;
				existingEntry.siteId = wifiData.siteId;
				existingEntry.zoneId = wifiData.zoneId;
				existingEntry.source = "Wifi Detection";
			  }
			} else {
				newDiscoveredList.push({
					detectionTime: wifiData.detectionTime,
					clientReference: clientReference,
					siteId: wifiData.siteId,
					zoneId: wifiData.zoneId,
					source: "Wifi Detection",
					thermalAlert: undefined
				})
			}
		  });

		  const updatedDiscoveredMap = new Map(
			newDiscoveredList.map((item) => [item.clientReference, item])
		  );

		  Object.entries(faceMap).forEach(([clientReference, faceData]) => {
			const existingEntry = updatedDiscoveredMap.get(clientReference);

			if (existingEntry) {
			  const faceTime = new Date(faceData.detectedAt);
			  const newTime = new Date(existingEntry.detectionTime);
		  
			  if (faceTime > newTime) {
				existingEntry.detectionTime = faceData.detectedAt;
				existingEntry.siteId = faceData.zone.siteId;
				existingEntry.zoneId = faceData.zone.zoneId;
				existingEntry.source = "Face Detection";
			  }
			} else {
				newDiscoveredList.push({
					detectionTime: faceData.detectedAt,
					clientReference: clientReference,
					siteId: faceData.zone.siteId,
					zoneId: faceData.zone.zoneId,
					source: "Face Detection",
					thermalAlert: undefined
				})
			}
		  });
		
		const mergedWithThermal = newDiscoveredList.map(el => {
			el.thermalAlert = thermalMap[el.clientReference];
			return el;
		});

		thermalMap[null] &&
			mergedWithThermal.push({
				clientReference: null,
				detectionTime: thermalMap[null].detectedAt,
				siteId: thermalMap[null].zone.siteId,
				thermalAlert: thermalMap[null],
				zoneId: thermalMap[null].zone.zoneId,
			});

		let filteredBySite = mergedWithThermal
		if (siteId !== "null")
			filteredBySite = mergedWithThermal.filter(
				el => el.siteId === siteId,
			);
		const zoneItems =
			zoneId && zoneId !== 'null'
				? filteredBySite
					.filter(item => {
						return item.zoneId ? item.zoneId === zoneId : false;
					})
					// Sort by reverse chronological order
					.sort(
						(item1, item2) =>
							moment(item2.detectionTime).unix() -
							moment(item1.detectionTime).unix(),
					)
				: filteredBySite.sort(
					(item1, item2) =>
						moment(item2.detectionTime).unix() -
						moment(item1.detectionTime).unix(),
				);
		const thermalItems =
			enabledVerticals.includes('thermal') &&
				thermalId &&
				thermalId !== 'null'
				? thermalId === 'fever'
					? zoneItems.filter(item => item.thermalAlert != null)
					: zoneItems.filter(item => item.thermalAlert == null)
				: zoneItems;
		return (
			<PageContainer>
				<PageContent className={'no-btm-padding'}>
					<PageContent.Main>
						<div className="live-view">
							<Row gutter={16}>
								<Col md={12}>
									<ZoneFilter
										onZoneChange={this.handleSiteChange}
										zoneId={siteId}
										zones={sites}
										placeholder="Select a site"
										idKey="siteId"
										nameKey="description"
										optAll={{
											label: 'All sites',
											value: 'null',
										}}
									/>

									<ZoneFilter
										onZoneChange={this.handleZoneChange}
										zoneId={zoneId}
										zones={zones}
										placeholder="Select a zone"
										idKey="zoneId"
										nameKey="name"
										optAll={{
											label: 'All zones',
											value: 'null',
										}}
										disabled={siteId === undefined}
									/>

									{enabledVerticals.includes('thermal') && (
										<ZoneFilter
											onZoneChange={
												this.handleThermalChange
											}
											zoneId={thermalId}
											zones={thermalSelector}
											placeholder="Select Fever Detection"
											idKey="value"
											nameKey="name"
											optAll={{
												name: 'All Persons',
												value: 'null',
											}}
										/>
									)}
								</Col>
								<Col md={12}>
									<FilterBar setURLHref={this.setURLHref} onSearchChange={this.handleSearchChange} />
								</Col>
								<Col md={12}>
									<SecurityMessaging
										list={
											enabledVerticals.includes('thermal')
												? securityMessages
												: []
										}
									/>
								</Col>
							</Row>
							<GridCards list={thermalItems} siteId={siteId} />
						</div>
					</PageContent.Main>
				</PageContent>
			</PageContainer>
		);
	}
}

export const selector = createStructuredSelector({
	discoveredList: liveDiscoverySelector,
	thermalAlertsList: liveThermalDiscoverySelector,
	faceAlertsList: liveFaceDiscoverySelector,
	wifiAlertsList: liveWifiDiscoverySelector,
	securityMessages: liveSecurityMessagingSelector,
	sitesList: ({ sites }) => sites.list,
	zonesList: ({ sites }) => sites.zonesList,
	verticalConfig: ({ user: { currentUser } }) => currentUser.verticalConfig,
	holdersList: holdersSelector,
	user: userSelector,
	operatorSite: operatorSiteDetailsSelector,
	operatorSiteDetailsStatus: operatorSiteDetailsStatusSelector,
	zonesCheckinCheckoutInfo: zonesCheckinCheckoutInfoSelector
});

export const mapDispatchToProps = dispatch => ({
	listSites: params => dispatch(listSites(params)),
	listZones: params => dispatch(listZones(params)),
	listenToSubscriptions: params => dispatch(listenToSubscriptions(params)),
	listenToThermalSubscriptions: params =>
		dispatch(listenToThermalSubscriptions(params)),
	listenToFaceSubscriptions: params =>
		dispatch(listenToFaceSubscriptions(params)),
	listenToWifiSubscriptions: params =>
		dispatch(listenToWifiSubscriptions(params)),
	listenToSecuritySubscriptions: params =>
		dispatch(listenToSecuritySubscriptions(params)),
	getSitesList: params => dispatch(actions.getSitesList(params)),
	getZonesList: params => dispatch(actions.getSitesZonesList(params)),
	logUserTab: params => dispatch(logUserTab(params)),
	listHolders: params => dispatch(listHolders(params)),
	getOperatorSite: params => dispatch(getOperatorSite(params)),
	listCheckinCheckoutZones: params => dispatch(listCheckinCheckoutZones(params))
});

export default compose(
	userIsAuthenticatedRedir,
	liveViewEnabledRedir,
	withRouter,
	withClientId,
	connect(selector, mapDispatchToProps),
)(LiveView);


// WEBPACK FOOTER //
// ./src/pages/live-view/index.js